// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3dWX5","buttons":"SendReceipts_buttons__2i7of","email":"SendReceipts_email__laXxz","bookApptTitle":"SendReceipts_bookApptTitle__wyoXt"};